"use client";
import React from "react";

const TestimonialSection = () => {
  return (
    <section className="relative py-24 bg-white overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-accent/5 rounded-full blur-[150px] -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-accent/5 rounded-full blur-[150px] translate-x-1/2 translate-y-1/2" />
      
      <div className="relative max-w-4xl mx-auto px-6">
        {/* Quote icon */}
        <div className="flex justify-center mb-8">
          <svg className="w-16 h-16 text-accent/20" fill="currentColor" viewBox="0 0 24 24">
            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
          </svg>
        </div>

        {/* Quote text */}
        <blockquote className="text-center">
          <p className="text-2xl md:text-3xl lg:text-4xl font-medium text-jacarta-700 leading-relaxed mb-8">
            SynthiaHire has transformed how we screen candidates. What used to take our team{" "}
            <span className="text-accent">
              days now takes minutes
            </span>
            , and the quality of candidates reaching our interview stage has significantly improved.
          </p>
          
          <footer className="flex flex-col items-center">
            <div className="w-16 h-16 rounded-full bg-accent flex items-center justify-center text-white text-xl font-bold mb-4">
              HR
            </div>
            <cite className="not-italic">
              <span className="block text-jacarta-700 font-semibold text-lg">HR Director</span>
              <span className="block text-jacarta-500 text-sm mt-1">Leading BFSI Company</span>
            </cite>
          </footer>
        </blockquote>

        {/* Decorative dots */}
        <div className="absolute top-1/2 left-8 -translate-y-1/2 hidden lg:flex flex-col gap-2">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="w-1.5 h-1.5 rounded-full bg-accent/20" />
          ))}
        </div>
        <div className="absolute top-1/2 right-8 -translate-y-1/2 hidden lg:flex flex-col gap-2">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="w-1.5 h-1.5 rounded-full bg-accent/20" />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
